import React from "react";
import "./cardComponent.css";
import CardBackground from "../../assets/images/cardBackground.svg";
import CardActiveBackground from "../../assets/images/CardActiveBackground.svg";

export const CardComponent = ({ title, value, name, onClick, active }) => {
  return (
    <>
      <div
        className={`col-12 card-component p-relative ${
          active && "card-component-active"
        }`}
        onClick={onClick}
      >
        <img
          src={active ? CardActiveBackground : CardBackground}
          alt="pattern"
          className="background-position"
        />
        <div>
          <div className="card-title">{title}</div>
          <div className="card-title">{name}</div>
        </div>
        <span className="card-value">{value}</span>
      </div>
      ;
    </>
  );
};
